<template>
  <div class="fixed-header-button">
    <v-flex md12>
      <v-layout row wrap justify-end>
        <slot></slot>
      </v-layout>
    </v-flex>
  </div>
</template>

<script>
export default {}
</script>

<style>
.fixed-header-button {
  position: fixed;
  z-index: 10;
  top: 65px;
  right: 80px;
  max-width: 60%;
}
</style>
